import { Link } from 'react-router-dom'

export function NotFound() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-8">
      <div className="text-center">
        <h1 className="text-6xl font-heading font-bold text-foreground-muted mb-4">404</h1>
        <p className="text-lg text-foreground mb-6">Page not found</p>
        <Link
          to="/wachtrij"
          className="px-4 py-2 bg-accent text-background font-medium rounded-lg hover:bg-accent-hover hover:shadow-glow transition-all"
        >
          Naar de wachtrij
        </Link>
      </div>
    </div>
  )
}
